import {
	Component,
	Input,
	Output,
	EventEmitter,
	OnInit
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Product } from 'go-modules/services/group/product';
import { Group as GroupModel } from 'go-modules/models/group-dep/group.factory';

@Component({
	selector: 'product-details-form',
	templateUrl: 'product-details-form.component.html',
	styleUrls: ['./product-details-form.component.scss'],
	standalone: false
})
export class ProductDetailsFormComponent implements OnInit {
	@Input() public group: ReturnType<typeof GroupModel>;
	@Input() public products: Product[] = [];
	@Input() public optionProduct: Product | null = null;
	@Output() public selectedProductChange = new EventEmitter<{ product: Product }>();

	public productControl = new FormControl<number | null>(null);

	public ngOnInit (): void {
		const defaultProduct = this.products.find((p) =>
			p.product_id === this.optionProduct?.product_id
		) ?? this.products[0];
		this.productControl.setValue(defaultProduct.product_id);
		this.selectedProductChange.emit({ product: defaultProduct });
	}

	public onProductChange (): void {
		const selectedId = this.productControl.value;
		const selectedProduct = this.products.find((p) => p.product_id === selectedId);
		this.selectedProductChange.emit({ product: selectedProduct });
	}
}
